import Link from "next/link";
import { Button } from "@/components/ui/button";

type BlogPaginationProps = {
  page: number;
  totalPages: number;
  q: string;
  tag: string;
};

function pageHref(page: number, q: string, tag: string) {
  return {
    pathname: "/blog",
    query: {
      ...(q ? { q } : {}),
      ...(tag ? { tag } : {}),
      page,
    },
  };
}

export function BlogPagination({
  page,
  totalPages,
  q,
  tag,
}: BlogPaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-3 border-t pt-6">
      {page <= 1 ? (
        <Button variant="outline" disabled>
          Previous
        </Button>
      ) : (
        <Button asChild variant="outline">
          <Link href={pageHref(page - 1, q, tag)}>Previous</Link>
        </Button>
      )}

      <p className="text-sm text-muted-foreground">
        Page {page} of {totalPages}
      </p>

      {page >= totalPages ? (
        <Button variant="outline" disabled>
          Next
        </Button>
      ) : (
        <Button asChild variant="outline">
          <Link href={pageHref(page + 1, q, tag)}>Next</Link>
        </Button>
      )}
    </div>
  );
}
